import { useRef } from "react";
import "./legend.css";

import { all_protos } from "./protos/all_protos";
import { useMobileContext } from "contexts/MobileContext";

export default function Legend({ legendItems, children }) {
  const { isTouch, isLayerSelectionExpanded, isStatsPanelExpanded } =
    useMobileContext();
  // Auto-collapse legend when layer selection or stats panel is expanded on mobile
  const isOpen = isTouch
    ? !isLayerSelectionExpanded && !isStatsPanelExpanded
    : true;
  const ref = useRef(null);

  const transformOffset =
    !isOpen && ref.current
      ? { transform: `translateX(${-ref.current.offsetWidth - 5}px)` }
      : {};

  if (legendItems.length === 0) return null;

  return (
    <div
      className={"legend-container" + (isOpen ? " open" : "")}
      style={transformOffset}
    >
      <div className="legend-content" ref={ref}>
        {legendItems.map((x, i) => {
          const Proto = all_protos[x.layer_type];
          return (
            <Proto legend={x} key={x.layer_title}>
              {children}
            </Proto>
          );
        })}
      </div>
    </div>
  );
}
